import { createFileRoute } from "@tanstack/react-router";
import { ComingSoon } from "@client/components/coming-soon";

export const Route = createFileRoute("/_app/search")({
  component: () => <ComingSoon title="AI 搜索" />,
});
